<script>
import { BFormFile } from "bootstrap-vue";

export default {
  extends: BFormFile
};
</script>